import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import AwsConnectSucess from 'views/pages/AwsConnectSuccess';
import PdfSuccess from 'views/pages/PdfSuccess';
// maintenance routing
const ArnForm = Loadable(lazy(() => import('views/pages/ArnForm')));
const AwsConnect = Loadable(lazy(() => import('views/pages/AwsConnect')));
const CalculatorPage = Loadable(lazy(() => import('views/pages/CalculatorPage')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <ArnForm />
        },
        {
            path: '/aws',
            element: <ArnForm />
        },
        {
            path: '/connect',
            element: <AwsConnect />
        },
        {
            path: '/connectSucess',
            element: <AwsConnectSucess />
        },
        {
            path: '/PdfSuccess',
            element: <PdfSuccess />
        },
        {
            path: '/calculator',
            element: <CalculatorPage />
        }
    ]
};

export default AuthenticationRoutes;
